import React, { useMemo, useEffect, useState } from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import Select from "components/Select";
import { getSelectStyles } from "../utils/selectStyles";
import { getActiveColorStyle } from "../utils/colorUtils";
import { useTranslation } from 'react-i18next';

// CustomInputOrSelect: Select + Custom Input Component (engine tarzı)
const CustomInputOrSelect = ({
  label,
  value,
  onChange,
  options = [],
  isCustom,
  setIsCustom,
  prevValue,
  setPrevValue,
  placeholder = '',
  customPlaceholder = 'Enter custom value',
  required,
  invalid,
  fieldKey,
  setFormData,
  isClearable = true,
  customSelectStyles,
  textInputClassName,
  textInputStyle = { borderRadius: 0, fontSize: "14px" },
}) => {
  const { t } = useTranslation();
  
  return (
  <FormGroup>
    <Label>
      {typeof label === 'string' && label.includes('<span') ? (
        <>
          {label.split('<span')[0]}
          <span style={{ color: '#dc3545' }}>*</span>
          {label.split('</span>')[1]}
        </>
      ) : (
        label
      )}
    </Label>
    {!isCustom ? (
        <Select
          styles={{
            ...customSelectStyles,
            control: (provided, state) => ({
              ...customSelectStyles.control(provided, state),
            })
          }}
        className="react-select"
        placeholder={placeholder || t('common.select')}
        name={fieldKey}
        isSearchable={false}
        closeMenuOnSelect={true}
        value={value ? {
          value: value,
          label: options.find(opt => (opt.value || opt) === value)?.label || value
        } : null}
        onChange={(option) => {
          if (option?.value === 'custom') {
            setPrevValue && setPrevValue(value);
            setIsCustom(true);
            onChange('');
          } else {
            onChange(option?.value || '');
          }
        }}
        options={[
          ...(value && !options.some(opt => (opt.value || opt) === value) ? [{
            value: value,
            label: value
          }] : []),
          ...options.map(opt => ({
            value: opt.value || opt,
            label: opt.label || opt
          })),
          { value: 'custom', label: t('common.custom') }
        ]}
        isClearable={isClearable}
      />
    ) : (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Input
          className={textInputClassName}
          style={textInputStyle}
          type="text"
          placeholder={customPlaceholder}
          value={value}
          onChange={e => onChange(e.target.value)}
          required={required}
          invalid={invalid}
        />
        <Button
          color="danger"
          size="sm"
          onClick={() => {
            setIsCustom(false);
            if (setPrevValue && prevValue !== undefined) {
              setFormData && setFormData(prev => ({ ...prev, [fieldKey]: prevValue }));
            }
          }}
          title={`Cancel custom ${label?.toLowerCase()}`}
        >
          ×
        </Button>
      </div>
    )}
    {invalid && (
      <div style={{ color: '#dc3545', fontSize: 12 }}>{t('common.required')}</div>
    )}
  </FormGroup>
  );
};

export default CustomInputOrSelect; 